import TableRow from './TableRow';
import React, { useContext, useState, useEffect } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import CasesAPI from 'api/CasesAPI';
import { Link } from 'react-router-dom';
import { formatDate } from 'utils/dateFormater';


type Hit = {
  id: string,
  col1: string,
  col2: string,
}

const Tickets: React.FC = () => {
  const { cur_user } = useContext(GlobalContext);

  const itemsPerPage = 5;
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ loaded, setLoaded ] = useState<boolean>(false);
  const [ totalPages, setTotalPages ] = useState(1);
  const [ currentItems, setCurrentItems ] = useState<any[]>([]);


  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, Math.ceil(cases?.length / itemsPerPage)));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const [ cases, setCases ] = useState<Hit[]>([]);

  // ANALYTICS VAULT CASES
  const getCasesFromAPI = async(query: any) => {
    const mongoReq = {
      query: {
        ...query,
        groupId: cur_user.selected_team?.id,
        $or: [
          { sharedWith: cur_user.basics?.id },
          { sharedWith: cur_user.basics?.email },
          { createdBy: cur_user.basics?.id }
        ]
      },
      projection: {
        ticketName: 1,
        curTotal: 1,
        lastUpdate: 1,
        createdAt: 1
      },
    };
    const resp = await CasesAPI.searchCases(mongoReq);
    if (resp?.success) {
      const arr: Hit[] = [];
      resp.result.forEach((obj: any) => {
        arr.push({
          id: obj._id,
          col1: obj.ticketName,
          col2: obj.curTotal > 0 && obj.lastUpdate ? formatDate(obj.lastUpdate) : formatDate(obj.createdAt.substring(0, 10))
        });
      });
      setCases(arr);
      setTotalPages(Math.max(1, Math.ceil(resp.result.length / itemsPerPage)));
      setLoaded(true);
    }
  };

  useEffect(() => {
    if (cur_user.selected_team) {
      getCasesFromAPI({});
    }
  }, [ cur_user.selected_team ]);

  useEffect(() => {
    if (cases.length) {
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      setCurrentItems(cases.slice(indexOfFirstItem, indexOfLastItem));
    }
  }, [ currentPage, cases ]);

  return (
    <>
      <div className='home-ticket'>
        <div className='home-tickets-header'>
          <div className='home-tickets-header-support'>
            <div className='home-tickets-header-support-badge'>
              <div className='home-tickets-header-support-badge-cont'>
                <div className='home-tickets-header-support-badge-sec'>
                  <div className='home-tickets-header-support-badge-sec-left'>Ticket Updates</div>
                  <Link to='/bite-monitor'>
                    <div className='home-tickets-header-support-badge-sec-right'>View All</div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='audit-doc-tabe-col'>
          <div className='audit-doc-tabe-col-left-cells'>
            <div>
              <div className='audit-doc-tabe-col-left-cell-text'>Ticket Name</div>
            </div>
          </div>
          <div className='audit-doc-tabe-col-right-cell'>
            <div>
              <div className='audit-doc-tabe-col-left-cell-text'>Last Updated</div>
            </div>
          </div>
        </div>
        <div className='home-tickets-row'>
          {loaded && currentItems.length ? (
            currentItems?.map((_item: any, index: number) => (
              <React.Fragment key={index}>
                <TableRow key={index} item={_item}/>
                {index < 5 && (
                  <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
                )}
              </React.Fragment>
            ))
          ) : loaded && !cases.length ? (
            <div className='homepage-notifications-coming-soon' style={{ width: '100%' }}>
              No Tickets Found
            </div>
          ) : (
            <div className='loader'>Loading...</div>
          )}
        </div>

        <div className='activity-cont-frame-pagination'>
          <div className='activity-cont-frame-pagination-text'>Page {currentPage} of {totalPages}</div>
          <div className='activity-cont-frame-pagination-action'>
            <div className='activity-cont-frame-pagination-action-prev' onClick={handlePrevPage}>
              <div className='activity-cont-frame-pagination-action-text'>Previous</div>
            </div>
            <div className='activity-cont-frame-pagination-action-prev' onClick={handleNextPage}>
              <div className='activity-cont-frame-pagination-action-text'>Next</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tickets;
